// WHICH WASHES LEAD, AND WHICH ONE A BOOKING STARTS ON. Imports nothing, so
// node --test can run it (wash-order.test.mjs).
//
// Robin, 25 Oct 2026: "I would prob autoselect mini valet, and order exterior
// wash + wax, the mv, then mv plus" (docs/DECISIONS.md). The server's
// CustomerCatalogue::BASE_ENTRIES is in this order and flags Mini Valet
// `default_wash`; this file is what the booking screen does with the list.

// The three washes every customer-facing list starts with, in this order.
// The rest follow in the order they arrive.
export const LEAD_WASH_NAMES = ['Exterior Wash & Wax', 'Mini Valet', 'Mini Valet PLUS']

// The wash a booking starts on when nothing names one (no ?service=, no
// draft): the row flagged `defaultWash`, else the `mostBooked` one, else the
// first base wash. A link or a draft is applied on top and always wins.
export const defaultWashFrom = services => {
  const bases = (services || []).filter(service => service && service.group === 'base')
  return bases.find(service => service.defaultWash) || bases.find(service => service.mostBooked) || bases[0]
}

// THE SAME WASH, OFF THE CATALOGUE META RATHER THAN THE SERVICES API
// (31 Oct 2026). The fold's one button names it, so it has to be known
// synchronously, before any XHR, from the `gwmc:catalogue` rows
// (MetaTags::Helper#fold_catalogue, lib/page-prices.js readWashes), which
// carry `default: true` on it. The row, or null when the server has not said:
// a null slug books the same wash anyway (BookingLinks.general opens on
// CustomerCatalogue::DEFAULT_WASH), it just leaves the picker open, so there
// is nothing here to guess and no name to type as a fallback.
export const defaultWash = washes =>
  (washes || []).find(wash => wash && wash.default && wash.slug) || null

// The lead three first, then everything else in its own order.
export const leadFirst = washes => {
  const list = (washes || []).filter(Boolean)
  const lead = LEAD_WASH_NAMES.map(name => list.find(wash => wash.name === name)).filter(Boolean)
  return [...lead, ...list.filter(wash => !lead.includes(wash))]
}
